import { PointProps, Polygon } from '../types';

export const pointsToFlatArray = (points: PointProps[]): number[] => {
  return points.flatMap(({ x, y }) => [x, y]);
};

export const generateId = (prefix = '') => {
  const randomPart = Math.random().toString(36).substring(2, 10);
  const timestampPart = Date.now().toString(36);

  return prefix ? `${prefix}_${randomPart}${timestampPart}` : `${randomPart}${timestampPart}`;
};

export const generateDefaultPolygon = (name?: string): Polygon => {
  return {
    id: generateId('polygon'),
    name: name || `Polygon ${new Date().toISOString().slice(0, 16)}`,
    points: [
      { id: generateId('point'), x: 300, y: 200 },
      { id: generateId('point'), x: 200, y: 200 },
      { id: generateId('point'), x: 200, y: 300 },
      { id: generateId('point'), x: 300, y: 300 },
    ],
    isSelected: true,
  };
};

export const updatePointCoordinates = (
  points: PointProps[],
  pointId: string,
  newX: number,
  newY: number,
): PointProps[] => {
  return points.map((point) => (
    point.id === pointId ? { ...point, x: newX, y: newY } : point
  ));
};

export const moveAllPoints = (
  points: PointProps[],
  deltaX: number,
  deltaY: number,
): PointProps[] => {
  return points.map((point) => ({
    ...point,
    x: point.x + deltaX,
    y: point.y + deltaY,
  }));
};

export const normalizedToPixel = (
  normalized: string,
  dimension: number,
): number => {
  return parseFloat(normalized) * dimension;
};

export const pixelToNormalized = (
  pixel: number,
  dimension: number,
): string => {
  return (pixel / dimension).toFixed(4);
};

export const denormalizePolygonPoints = (points: { x: number, y: number }[], canvasWidth: number, canvasHeight: number) => {
  return points.map((point) => ({
    id: generateId('point'),
    x: Math.round(point.x * canvasWidth),
    y: Math.round(point.y * canvasHeight),
  }));
};
